export default {
  reportChartDates(state) {
    const { values = [] } = state.chartData;

    return values
      .filter(item => item.values)
      .map(item => item[0]);
  },
  reportChartValues(state) {
    const { values = [] } = state.chartData;

    return values[0]
      .map((row, i) => values.map(col => col[i]))
      .slice(1, values[0].length);
  },
  reportChartSeries(state, getters) {
    const { labels = [] } = state.chartData;

    return labels
      .map((labelItem, index) => ({
        name: labelItem,
        data: getters.reportChartValues[index],
      }));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/delivered-provider/store/getters.js